import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
var _effectorFileName = "/builds/gmini/front-common/src/classifier-editor/Common/type.ts";
import "core-js/modules/es.array.join.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { assertNever } from '@gmini/utils';
export var Tree;

(function (_Tree) {
  var Item;

  (function (_Item) {
    var BimEntity;

    (function (_BimEntity) {
      var create = _BimEntity.create = function (source) {
        return _objectSpread({
          type: 'TreeItemBimEntity',
          key: buildKey(source)
        }, source);
      };

      var buildKey = _BimEntity.buildKey = function (source) {
        return [source.node.type, source.node.id, source.reference.id].join(':');
      };

      var buildBranchKey = _BimEntity.buildBranchKey = function (_ref) {
        var parentRefId = _ref.parentRefId;
        return "Ref:".concat(parentRefId);
      };
    })(BimEntity || (BimEntity = _Item.BimEntity || (_Item.BimEntity = {})));

    var ClassifierEntity;

    (function (_ClassifierEntity) {
      var create = _ClassifierEntity.create = function (source) {
        return _objectSpread({
          type: 'TreeItemClassifierEntity',
          key: buildKey(source)
        }, source);
      };

      var buildKey = _ClassifierEntity.buildKey = function (source) {
        return [source.node.type, source.node.id].join(':');
      };

      var buildBranchKey = _ClassifierEntity.buildBranchKey = function (_ref2) {
        var parentClsId = _ref2.parentClsId;
        return "Cls:".concat(parentClsId);
      };
    })(ClassifierEntity || (ClassifierEntity = _Item.ClassifierEntity || (_Item.ClassifierEntity = {})));

    function create(source) {
      switch (source.type) {
        case 'TreeItemBimEntity':
          return BimEntity.create(source);

        case 'TreeItemClassifierEntity':
          return ClassifierEntity.create(source);
      }
    }

    _Item.create = create;

    var buildKey = _Item.buildKey = function (source) {
      return 'reference' in source ? BimEntity.buildKey(source) : ClassifierEntity.buildKey(source);
    };

    function getUniqueBranchId(treeNode) {
      switch (treeNode.type) {
        case 'TreeItemBimEntity':
          return treeNode.reference.id;

        case 'TreeItemClassifierEntity':
          return treeNode.node.id;

        default:
          return assertNever('treeNode.type', treeNode);
      }
    }

    _Item.getUniqueBranchId = getUniqueBranchId;
  })(Item || (Item = _Tree.Item || (_Tree.Item = {})));

  var SystemItem;

  (function (_SystemItem) {
    var LoadMore;

    (function (_LoadMore) {
      function create(parentItem) {
        return {
          type: 'TreeItemLoadMore',
          parentItem: parentItem,
          key: buildKey({
            parentItem: parentItem
          })
        };
      }

      _LoadMore.create = create;

      function buildKey(source) {
        return "TreeItemLoadMore:".concat(source.parentItem.key);
      }

      _LoadMore.buildKey = buildKey;
    })(LoadMore || (LoadMore = _SystemItem.LoadMore || (_SystemItem.LoadMore = {})));

    var AddNode;

    (function (_AddNode) {
      function create(status, parentItem) {
        return {
          type: 'TreeItemAddNode',
          parentItem: parentItem,
          status: status,
          key: buildKey({
            parentItem: parentItem
          })
        };
      }

      _AddNode.create = create;

      function buildKey(source) {
        return "TreeItemAddNode:".concat(source.parentItem.key);
      }

      _AddNode.buildKey = buildKey;
    })(AddNode || (AddNode = _SystemItem.AddNode || (_SystemItem.AddNode = {})));
  })(SystemItem || (SystemItem = _Tree.SystemItem || (_Tree.SystemItem = {})));
})(Tree || (Tree = {}));